import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	align-content: center;
	flex-direction: column;
	gap: 2rem;
`;

export const LegendHeader = styled.div`
	:hover {
		cursor: pointer;
	}
`;

export const LegendHeaderLine = styled.div`
	position: sticky;
	top: 0;
	background: var(--white);
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 2rem;
	width: 100%;
	justify-content: space-between;
	padding: var(--padding-1) 0;
`;

export const CodCardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2rem;
	height: 80%;
`;
